/**
 * Customer Overview tab — eager gate twin (design-wired).
 *
 * The wired screen renders the design `AdminCustomerOverview`, which brings its
 * OWN console shell (rail + topbar) and draws the customer head + tab strip. So
 * mounting it inside the zinc `/clawinstall/admin` layout (whose `$customerId`
 * layout draws its own head/tabs) would double the chrome. The route therefore
 * lives under `admin_/customers/$customerId/` — TanStack's trailing-underscore
 * escape keeps the `/clawinstall/admin/customers/<id>/overview` URL while opting
 * OUT of that layout — and re-applies the SAME admin gate here in `beforeLoad`.
 * That guard runs server-side and bounces a non-admin before the page loads.
 *
 * The page component and its atom/RPC imports are deferred to
 * `overview.lazy.tsx` so they never land in the always-loaded `main` chunk.
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";

import { requireAdmin } from "~/lib/server-admin.ts";

export const Route = createFileRoute("/clawinstall/admin_/customers/$customerId/overview")({
  // oxlint-disable-next-line eslint-js/no-restricted-syntax -- TanStack redirects require async/await
  beforeLoad: async () => {
    // oxlint-disable-next-line eslint-js/no-restricted-syntax -- TanStack redirects require async/await
    const auth = await requireAdmin();
    return { auth };
  },
});
